import cs from "element-plus/es/locale/lang/cs";

export default {
  ...cs,
  el: {
    ...cs.el,
    datepicker: {
      ...cs.el.datepicker,
      year: "", // Do not show "year" label in datepicker
    },
    // element-plus's Czech locale leaves these untranslated ("Close this dialog")
    dialog: {
      ...cs.el.dialog,
      close: "Zavřít",
    },
    drawer: {
      ...cs.el.drawer,
      close: "Zavřít",
    },
    messagebox: {
      ...cs.el.messagebox,
      close: "Zavřít",
    },
  },
};
